"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIORITY_COLOR_CONFIG = void 0;
const graphql_1 = require("../../../../../__generated__/graphql");
const ui_components_1 = require("@groupby/ui-components");
exports.PRIORITY_COLOR_CONFIG = {
    [graphql_1.PriorityTasksPriority.P1]: { color: ui_components_1.baseColors.red },
    [graphql_1.PriorityTasksPriority.P2]: { color: ui_components_1.baseColors.orange400 },
    [graphql_1.PriorityTasksPriority.P3]: { color: ui_components_1.baseColors.primaryBlueAccent500 },
    [graphql_1.PriorityTasksPriority.P4]: { color: ui_components_1.baseColors.teal300 },
    [graphql_1.PriorityTasksPriority.P5]: { color: ui_components_1.baseColors.gray300 },
};
